var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router } from '@angular/router';
// import { StateService } from '@uirouter/angular';
import { MatDialog } from '@angular/material';
import { Subject, BehaviorSubject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { v1 as uuid } from 'uuid';
import { AppinfoService } from './../../services/appinfo.service';
import { CommonRequestService } from './../../services/common-request.service';
import { SocketService, SocketLogs } from './../../services/socket.service';
import { UserService } from './../../services/user.service';
import { AppSettings } from './../../app.settings';
import { LayerSelectModalComponent } from './layer-select-modal/layer-select-modal.component';
import { LayerPreviewModalComponent } from './jobs-field-mapping/layer-preview-modal/layer-preview-modal.component';
import { FP } from './../../../assets/TS/FileProcess';
import { AdminService } from 'app/services/admin.service';
var ContentJobsService = /** @class */ (function () {
    function ContentJobsService(dialog, router, 
    // private stateService: StateService,
    toastr, adminService, appinfoService, requestService, socketService, userService) {
        this.dialog = dialog;
        this.router = router;
        this.toastr = toastr;
        this.adminService = adminService;
        this.appinfoService = appinfoService;
        this.requestService = requestService;
        this.socketService = socketService;
        this.userService = userService;
        // Wizard on or off
        this.wizard = 'off';
        // Layers for uploading
        this.layers = new BehaviorSubject([]);
        // Uploading messages by processId
        this.uploadingLogs = new BehaviorSubject({});
        // On uploading finish
        this.onUploadingFinish = new Subject();
        // public uploadWithQcProcesses: {
        // 	[uploadProcessId: string]: {
        // 		qcProcessId: string;
        // 	};
        // } = {};
        //
        this.rawFiles = {
            fgdb: {},
            fgdbZip: {},
            shp: {},
            shpZip: {}
        };
    }
    // Upload files
    ContentJobsService.prototype.uploadFiles = function (qcType) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var fileListJson;
                        var formData = new FormData();
                        fileListJson = _this.getFilesJson();
                        formData.append('sessionId', _this.appinfoService.getSessionUuid());
                        formData.append('userId', _this.userService.getUserInfo().userId.toString());
                        formData.append('userSubscriptionId', _this.userService.getUserInfo().userSubId.toString());
                        formData.append('spec', JSON.stringify(fileListJson));
                        formData.append('qcType', qcType);
                        for (var _i = 0, _a = Object.keys(_this.rawFiles); _i < _a.length; _i++) {
                            var fileType = _a[_i];
                            var files = _this.rawFiles[fileType];
                            for (var _b = 0, _c = Object.keys(files); _b < _c.length; _b++) {
                                var file = _c[_b];
                                formData.append('uploads', files[file].zip);
                            }
                        }
                        // const toast = this.generateUploadingToast('info', this.generateUploadingToastMessage('processing'));
                        // Generate a temporary processId before the true processId is returned from the service call
                        var tempProcessId = uuid();
                        // Init a process for socketProcesses
                        _this.socketService.onInitProcess.next({
                            tempId: tempProcessId,
                            processType: 'Upload'
                        });
                        var url = AppSettings.serviceRootUrl + 'azgiv/file';
                        console.log('fileListJson: ', fileListJson);
                        return _this.requestService.requestPost(url, formData, function (rsp) {
                            var processesById = _this.uploadingLogs.getValue();
                            var processId = rsp.data.content;
                            // Update processId for socketProcesses
                            _this.socketService.onInitProcess.next({
                                tempId: tempProcessId,
                                processId: processId,
                                processType: 'Upload'
                            });
                            // Register the process for socketLogs
                            _this.socketService.registerProcessById(rsp.data.content, processesById);
                            //
                            _this.uploadingLogs.next(processesById);
                            // Clear uploaded data
                            _this.rawFiles = {
                                fgdb: {},
                                fgdbZip: {},
                                shp: {},
                                shpZip: {}
                            };
                            _this.layers.next([]);
                            // // Store if need qc
                            // if (withQC) {
                            // 	this.uploadWithQcProcesses[processId] = {
                            // 		qcProcessId: null // will be updated when uploading is finished
                            // 	};
                            // }
                            resolve({
                                processId: processId
                            });
                        }, function (err) {
                            // Trigger a fake socket message to stop socket
                            _this.socketService.filePostSubject.next({
                                processId: tempProcessId,
                                processType: 'Upload',
                                isFinal: true,
                                isError: true,
                                isCanceled: false,
                                dataType: 'json',
                                data: { errorMessage: '', errorDetail: '' },
                                timeStamp: new Date().toLocaleString('en-US')
                            });
                            reject(err);
                        });
                        // options);
                    })];
            });
        });
    };
    // Generate toast message
    ContentJobsService.prototype.generateUploadingToastMessage = function (type, msg) {
        msg = msg || '';
        switch (type) {
            case 'processing':
                return "<div>Uploading <div class=\"loading-dots\"></div></div>\n\t\t\t\t<div>" + msg + "</div>";
            case 'final':
                // Set Default msg
                msg = msg || "<div>Uploading completed.</div>";
                return msg;
        }
    };
    // Generate toast
    ContentJobsService.prototype.generateUploadingToast = function (type, message) {
        var _this = this;
        var toast;
        var config = Object.assign({}, this.socketService.toastrConfig);
        switch (type) {
            case 'info':
                toast = this.toastr.info(message, null, config);
                toast.onTap.subscribe(function () {
                    // this.stateService.go('jobsuploadlogs');
                    _this.router.navigate(['azgiv/jobs/upload-logs']);
                });
                break;
            case 'success':
                config.tapToDismiss = true;
                toast = this.toastr.success(message, null, config);
                toast.onTap.subscribe(function () {
                    // this.stateService.go('jobsfilesreview');
                    _this.router.navigate(['azgiv/review/data-view']);
                });
                break;
            case 'error':
                toast = this.toastr.error(message, null, this.socketService.toastrConfig);
                break;
            case 'warning':
                toast = this.toastr.warning(message, null, this.socketService.toastrConfig);
        }
        return toast;
    };
    // Read and process loaded files
    ContentJobsService.prototype.transformLoadedFiles = function (files) {
        return __awaiter(this, void 0, void 0, function () {
            var rsp, rsp2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, FP.FileUtility.groupFiles(files)];
                    case 1:
                        rsp = _a.sent();
                        return [4 /*yield*/, FP.FileUtility.processFilesByType(rsp)];
                    case 2:
                        rsp2 = _a.sent();
                        return [2 /*return*/, rsp2];
                }
            });
        });
    };
    // Read and process dropped files
    ContentJobsService.prototype.transformDroppedFiles = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            var rsp, rspGroupedFile, rsp2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, FP.FileUtility.getFilesFromDataTransferItems(items)];
                    case 1:
                        rsp = _a.sent();
                        if (!rsp) return [3 /*break*/, 4];
                        return [4 /*yield*/, FP.FileUtility.groupFilesMix(rsp)];
                    case 2:
                        rspGroupedFile = _a.sent();
                        return [4 /*yield*/, FP.FileUtility.processFilesByType(rspGroupedFile)];
                    case 3:
                        rsp2 = _a.sent();
                        return [2 /*return*/, rsp2];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContentJobsService.prototype.addRawFiles = function (addedFiles) {
        var merged = FP.GeneralUtility.mergeObjectsLevel1([this.rawFiles, addedFiles]);
        this.rawFiles = merged;
    };
    ContentJobsService.prototype.removeRawFilesByLayer = function (layer) {
        if (!layer) {
            console.log('Remove layer failed! layer: ' + layer);
            return;
        }
        var rawFile = this.rawFiles[layer.type][layer.fileName];
        switch (layer.type) {
            // Delete shp layer directly
            case 'shp':
                delete this.rawFiles[layer.type][layer.fileName];
                break;
            // The rest of types are processed in the same way
            default:
                delete this.rawFiles[layer.type][layer.fileName].layers[layer.name];
                if (!Object.keys(this.rawFiles[layer.type][layer.fileName].layers).length) {
                    delete this.rawFiles[layer.type][layer.fileName];
                }
        }
    };
    // Group and Filter files in a fgdb for reading
    ContentJobsService.prototype.filterFgdbFiles = function (filesByName) {
        var fileGroup = {};
        var filesExclude = ['a00000001', 'a00000002', 'a00000003', 'a00000005', 'a00000006', 'a00000007', 'a00000008'];
        for (var _i = 0, _a = Object.keys(filesByName); _i < _a.length; _i++) {
            var name_1 = _a[_i];
            var file = filesByName[name_1];
            // File name without extension
            var nameNoExt = name_1.slice(0, name_1.lastIndexOf('.'));
            var nameSplits = name_1.split('.');
            var extension = nameSplits[nameSplits.length - 1];
            extension = extension ? extension.toUpperCase() : '';
            // Filter out files that are not layer
            if (filesExclude.indexOf(name_1.split('.')[0]) !== -1) {
                continue;
            }
            // Filter out file types that are not needed
            if (extension !== 'GDBTABLX' && extension !== 'GDBTABLE') {
                continue;
            }
            if (!fileGroup[nameNoExt]) {
                fileGroup[nameNoExt] = {};
            }
            fileGroup[nameNoExt][extension] = file;
        }
        return fileGroup;
    };
    // getFilesJson(name, layersInfo) {
    // 	const filesJson = {
    // 		layers: [{
    // 			name: name,
    // 			layers: []
    // 		}]
    // 	};
    // 	// layersInfo.forEach((i) => {
    // 	// });
    // 	return filesJson;
    // }
    ContentJobsService.prototype.getFilesJson = function () {
        var _this = this;
        var fileLayers = [];
        var layers = this.layers.getValue();
        // Update rawFiles layers info
        layers.forEach(function (l) {
            var rawFile = _this.rawFiles[l.type][l.fileName];
            switch (l.type) {
                case 'shp':
                    rawFile.layerName = l.fileName;
                    rawFile.category = l.category;
                    rawFile.epsg = l.content.epsg || l.content.epsgInput;
                    rawFile.featureType = FP.FileSpec.convertFeatureType(l.content.type);
                    rawFile.maintainType = l.maintainType;
                    break;
                default:
                    var layer = rawFile.layers[l.name];
                    layer.layerName = l.name;
                    layer.category = l.category;
                    layer.epsg = l.content.epsg || l.content.epsgInput;
                    layer.featureType = FP.FileSpec.convertFeatureType(l.content.type);
                    layer.maintainType = l.maintainType;
            }
        });
        for (var _i = 0, _a = Object.keys(this.rawFiles); _i < _a.length; _i++) {
            var fileType = _a[_i];
            var files = this.rawFiles[fileType];
            switch (fileType) {
                case 'shp':
                    for (var _b = 0, _c = Object.keys(files); _b < _c.length; _b++) {
                        var f = _c[_b];
                        // const fileJson = this.getFeatureFileJson_SingleLayer(files[f], 'shapefile');
                        var fileJson = this.getFeatureFileJson_MultiLayers([files[f]], f, 'shapefile');
                        fileLayers.push(fileJson);
                    }
                    break;
                default:
                    for (var _d = 0, _e = Object.keys(files); _d < _e.length; _d++) {
                        var f = _e[_d];
                        var fileJson = this.getFeatureFileJson_MultiLayers(files[f].layers, f, fileType);
                        fileLayers.push(fileJson);
                    }
            }
        }
        return {
            state_cd: this.userService.getSelectedCustomerInfo('stateCode'),
            cus_id: this.userService.getCustomerIdByType(),
            files: fileLayers
        };
    };
    // Get fileJson of feature files including fgdb, fgdbZip, shpZip
    ContentJobsService.prototype.getFeatureFileJson_MultiLayers = function (layers, name, type) {
        var filesJson = FP.FileSpec.initFilesJsonSpatial();
        filesJson.uniqueName = uuid();
        switch (type) {
            case 'shapefile':
                filesJson.type = 'shapefile';
                filesJson.name = name + '.shp';
                break;
            case 'shpZip':
                filesJson.type = 'shapefile';
                filesJson.name = name + '.zip';
                break;
            case 'fgdb':
                filesJson.type = 'fgdb';
                filesJson.name = name;
                break;
            case 'fgdbZip':
                filesJson.type = 'fgdb';
                filesJson.name = name + '.zip';
        }
        for (var _i = 0, _a = Object.keys(layers); _i < _a.length; _i++) {
            var layer = _a[_i];
            var layerJson = this.getFeatureFileJson_SingleLayer(layers[layer], type, layers[layer].maintainType);
            filesJson.layers.push(layerJson);
        }
        return filesJson;
    };
    ContentJobsService.prototype.getFeatureFileJson_SingleLayer = function (file, type, maintainType) {
        var fileJson = FP.FileSpec.initLayerJson(false);
        fileJson.name = file.layerName;
        fileJson.sequence = null;
        fileJson.maint_type = maintainType;
        // fileJson.type = file.featureType;
        // This is not in use currently since proj4 and geom_col is obtained at backend
        fileJson.layer_spec = {
            // type: type,
            // srid: file.epsg || file.epsgInput,
            proj4: null,
            geom_col: null // 'geom'
        };
        var layerType = this.appinfoService.layerTypeList.find(function (t) {
            return t.name === file.category;
        });
        fileJson.type = layerType.code;
        // const cols = (layerType && layerType.standardCols) ? layerType.standardCols : [];
        // fileJson.attr_cols = cols.reduce((filtered, col) => {
        // 	if (col.matchedCol) {
        // 		filtered.push({
        // 			standard_name: col.colName,
        // 			col_name: col.matchedCol.name,
        // 			data_type: col.colType
        // 		});
        // 	}
        // 	return filtered;
        // }, []);
        var fields = (type === 'shapefile' || type === 'shpZip') ? file.info.fields : file.fields;
        // The text field need additional info: field length
        // For fgdb, use maxLength to represent length
        var lenghProp = (type === 'shapefile' || type === 'shpZip') ? 'length' : 'maxLength';
        fileJson.attr_cols = fields.map(function (col) {
            var standardName = null;
            var definedBy = null;
            if (col.matchedStandardCol && col.matchedStandardCol.colName) {
                standardName = col.matchedStandardCol.colName;
                // Specify whether the column is defined by nena or state
                switch (col.matchedStandardCol.definedBy) {
                    case 'NENA':
                        definedBy = 'nena';
                        break;
                    case 'GIV':
                        definedBy = 'GIV';
                        break;
                    default: definedBy = 'state';
                }
                // definedBy = col.matchedStandardCol.definedBy === 'NENA' ? 'nena' : 'state';
            }
            var formattedCol = {
                standard_name: standardName,
                col_name: col.name,
                data_type: col.LBType,
                col_length: null,
                defined_by: definedBy
            };
            if (col.LBType === 'text') {
                formattedCol.col_length = col[lenghProp];
            }
            return formattedCol;
        });
        return fileJson;
    };
    ContentJobsService.prototype.openLayerSelectWindow = function (data, successCallback) {
        var dialogRef = this.dialog.open(LayerSelectModalComponent, {
            width: '470px',
            height: '366px',
            data: data
        });
        return dialogRef.afterClosed().subscribe(function (rsp) {
            if (successCallback) {
                successCallback(rsp);
            }
        });
    };
    ContentJobsService.prototype.openPreviewDialogWindow = function (data) {
        this.dialog.open(LayerPreviewModalComponent, {
            width: '1267px',
            height: '600px',
            data: data
        });
    };
    return ContentJobsService;
}());
export { ContentJobsService };
